import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FilterModalModule } from '@helios/filter-modal'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { NfFormsModule } from '@northfork/ng-basics'
import { WorkbenchColumnManagerComponent } from '../column-manager/workbench-column-manager.component'
import { AggInfoColumnFilterComponent } from '../../grid/filters/agg-info-column-filter.component'
import { BulkCellEditorComponent } from '../bulk-transaction-modal/bulk-cell-editor.component'
import { BulkTransactionModalComponent } from '../bulk-transaction-modal/bulk-transaction-modal.component'
import { CollectionItemsModalComponent } from '../collection-items-modal/collection-items-modal.component'
import { EditTransactionModalComponent } from '../edit-transaction-modal/edit-transaction-modal.component'
import { UnmatchModalComponent } from '../unmatch-modal/unmatch-modal.component'
import { ValuePickerComponent } from '../value-picker/value-picker.component'
import { WorkbenchGridComponent } from './workbench-grid.component'

@NgModule({
  imports: [
    // Angular Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Third Party Modules
    NgSelectModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbTooltipModule,

    // Northfork Modules
    NfFormsModule,
    TableLayoutModule,

    // Helios Modules
    GenericComponentsModule,
    // Also supplies hs-column-type-picker, which the Aggregate Info grid-header filter hosts so the
    // picker in the column header and the one in the Filters modal are literally the same control.
    FilterModalModule,
  ],
  declarations: [
    WorkbenchGridComponent,
    UnmatchModalComponent,
    EditTransactionModalComponent,
    BulkTransactionModalComponent,
    BulkCellEditorComponent,
    CollectionItemsModalComponent,
    WorkbenchColumnManagerComponent,
    AggInfoColumnFilterComponent,
    ValuePickerComponent,
  ],
  exports: [WorkbenchGridComponent],
})
export class WorkbenchGridModule {}
